//首頁的靜態資料

export const heroImg = {
  logo: [
    {
      img: 'images/heroImg-logo-1.svg',
      imgAlt: '涵泊hero logo-1',
    },
    {
      img: 'images/heroImg-logo-2.svg',
      imgAlt: '涵泊hero logo-1',
    }
  ],
  imgs: [{
    img: 'images/index-heroImage-clean-1.jpg',
    imgSm: 'images/index-heroImage-clean-mobile-1.jpg',
    imgAlt: '涵泊hero image-1',
  },
  {
    img: 'images/index-heroImage-clean-2.jpg',
    imgSm: 'images/index-heroImage-clean-mobile-2.jpg',
    imgAlt: '涵泊hero image-2',
  }]
};

export const constructionProjectInfos = [{
  subTitle: `A tranquil soul <br>
			is the antidote to the city`,
  title: '寧靜的靈魂，才是城市的解藥',
  content: '',
  img: 'images/construction-project-img-1.jpg',
  imgAlt: '寧靜的靈魂，才是城市的解藥',
},
{
  subTitle: `Let loneliness
			<br>
			become a manifest.`,
  title: '讓  孤獨成為一種顯學',
  content: `當所有過往的驚艷與驚喜，<br>
							都轉變成為一種難以掀起波瀾的平淡。
							<br><br>
							你成為富豪世界的一條孤魂，<br>
							所有你愛的，愛你的，都發揮不了作用時，<br>
							你的街道，開始適應新的冷清。`,
  img: 'images/construction-project-img-2.jpg',
  imgAlt: '讓孤獨成為一種顯學',
},
{
  subTitle: `The overwhelming
			<br>
			sense of devouring.`,
  title: '巨大的吞噬感',
  content: '',
  img: 'images/construction-project-img-3.jpg',
  imgAlt: '巨大的吞噬感',
},
{
  subTitle: `The conversationalist
			<br>
			of the solitary traveler`,
  title: '孤獨旅人的對話者',
  content: '',
  img: 'images/construction-project-img-4.jpg',
  imgAlt: '孤獨旅人的對話者',
},
];

export const lotValueInfos = [{
  subTitle: '驕傲in台中',
  title: '永遠的台灣大道，邁向國際！',
  content: '一條台灣大道讓台中成功蛻變。隨新都心轉移，在這裡，企業的發跡、首代名宅聚落、金融大道、時尚文創基地…始終從科博館特區興起；國立科博館、IHG洲際酒店、SOGO百貨、誠品文創商圈等，奠定台中國際化都市新局面。',
  img: 'images/lot-value-image-1.jpg',
  imgAlt: '永遠的台灣大道，邁向國際！-配圖',
},
{
  subTitle: '海德in台中',
  title: '企業發跡的原鄉，科博館',
  content: '串連白金漢宮，海德公園為英皇室貴族而砌，周遭百年級博物館林立成就首屈一指地段，吸引全球名門貴冑、企業巨擘爭相齊聚。台中首座國家知識寶藏、擁萬坪森綠的科博館及植物園，是台中創業型企業主興家旺業的原鄉，他們長久愛戀這塊土地，乃出自名門DNA、考量家族血脈延續的初衷。',
  img: 'images/lot-value-image-2.jpg',
  imgAlt: '企業發跡的原鄉，科博館-配圖',
},
{
  subTitle: '表參道in台中',
  title: '國際人文場域，草悟道',
  content: '城市綠帶是一條時間河的堆疊；而人文地景來自人的內涵所釀造。科博草悟綠園道本是美好生活發源地，因知識的累積而生文創實力並淬煉出草悟綠園道，一路至國美館，3600米皆藝文與時尚，比美東京表參道，但多了「發想」題材，因為，這裡的人是最美的風景。',
  img: 'images/lot-value-image-3.jpg',
  imgAlt: '國際人文場域，草悟道-配圖',
},
{
  subTitle: '人文奇想的無牆美術館',
  title: '台中最令人「發想」綠園道',
  content: '這是來自任何子民走訪過的一致感言。源自科博館知識寶庫長年薰陶、跨越台灣大道延伸至國美館，草悟道上充滿想像的地景藝術與人文律動空間，展現出城市無限的獨特感。生命演化恐龍步道、人文裝置藝術，無牆美術館、誠品文創、草悟廣場、爵士樂章、微創場域…，沿途盡散落著與人文相遇的幸福。',
  img: 'images/lot-value-image-4.jpg',
  imgAlt: '台中最令人發想綠園道-配圖',
},
{
  subTitle: '以時尚舞動國際生活',
  title: '離不開的捨得，心存人亦在',
  content: '台中國際化步伐從科博館起走。第一家五星級飯店、第一家SOGO國際百貨；濃郁時尚增添生活完美度，低調隱富層峰從不捨離開，只因為見證台中國際時尚生活發展。',
  img: 'images/lot-value-image-5.jpg',
  imgAlt: '離不開的捨得，心存人亦在-配圖',
},
];

export const advantagesInfos = [{
  subTitle: '寧可成本高也不妥協',
  title: '縱橫世界  孤品獨藏',
  content: '「鄉林涵泊」特採用國際名宅專鑄營造工法，以高成本帷幕輕量建築來加強抗震，並採單元式全包覆立面及建構格柵飾板，讓外觀擁黃金比例的水平與垂直勻稱線條，且獨享四面環繞景觀優勢。在考量住的品質與舒適性，玻璃特以阻隔超過95%紫外線的Low-E複層玻璃打造，加上訂製窗台氣孔以高效率排熱，成為一棟會自然呼吸換氣的建築。',
  img: 'images/advantages-image-1.jpg',
  imgAlt: '縱橫世界孤品獨藏-配圖',
},
{
  subTitle: '註定會被記憶的建築',
  title: '360°環景  一窗一畫景',
  content: '如同貝聿銘大師強調自然美學的理念。「鄉林涵泊」被科博館萬坪森綠與草悟園道第一排圍合，因不捨綠意和美景被阻隔，堅持拆掉四面牆，成就出360°環景視野，獨享唯有世界頂級豪宅才能領略到的「一窗一畫景」，加上自然雕鏤出四面綠牆的光影美學，層峰住戶可隨心所欲將最美的窗景開在最愛的角落！',
  img: 'images/advantages-image-2.jpg',
  imgAlt: '360°環景一窗一畫景-配圖',
},
{
  subTitle: '中西並融  跨界美學精粹',
  title: '昔幣之形 富貴傳家意象',
  content: '在昔日土庫溪蜿蜒抱水玉帶，取商周財幣之形，以坐北朝南的帝王之向，集成聚金納財象徵。<br>採西方帷幕通透之器，特聘雪梨歌劇院LDP團隊操刀燈光計畫，打造出兼容中西美學精粹、水晶藝術登峰造極之作，達到最完美的跨界合融。<br>萬金買鄰，全棟量身打造153坪的單一坪數，並以一層一戶全隱私，僅獻18席層峰家族。',
  img: 'images/advantages-image-3.jpg',
  imgAlt: '昔幣之形富貴傳家意象-配圖',
},
];

export const featureInfos = [{
  title: '藝術光影藏經閣大廳',
  content: '光和影是貝聿銘賦于羅浮宮金字塔最重要的生命元素。為了光影美學，鄉林涵泊大開窗與門，不但造就一窗一綠景，也營造自然光影隨時間的變化而成一幅流動的藝術畫作。寬朗大廳再以豐藏藝術與書香揉合視覺，每件作品、每本書卷天天烙印著光影流動過的腳步。',
  img: 'images/feature-image-1.jpg',
  imgAlt: '藝術光影藏經閣大廳-配圖',
},
{
  title: '靜自然禪意會館',
  content: '猶如大自然裡的靜謐，長在樹梢的會館以無牆靜自然概念當起手，鋪陳涵碧禪簡度假意念，描繪出東方極簡淨悠聚會場域，並以空間詩人之姿挹注多情多感元素，讓心境從私領域祥和轉換成招待摯親友人的喜悅。',
  img: 'images/feature-image-2.jpg',
  imgAlt: '靜自然禪意會館-配圖',
},
{
  title: '涵碧自然度假會館',
  content: '不捨景色被阻隔而拆掉四面牆,造就一扇窗懷擁全視界。無垠藍天白雲、綠意窗景、花台簇擁、池面水波,巧妙呵成天光倒影,形成一幅收攬天地美景的絕美空中無邊際泳池會館。',
  img: 'images/feature-image-3.jpg',
  imgAlt: '涵碧自然度假會館-配圖',
},
];

export const landscapeInfos = [{
  img: 'images/landscape-img-1.jpg',
  imgAlt: 'landscape-1-配圖',
},
{
  img: 'images/landscape-img-2.jpg',
  imgAlt: 'landscape-2-配圖',
},
{
  img: 'images/landscape-img-3.jpg',
  imgAlt: 'landscape-3-配圖',
},
];

export const mastersInfos = [{
  title: '國際頂尖建築大師Kerry Hill',
  content: '合作設計的「日月潭、青島涵碧樓」享譽國際。',
  img: 'images/master-img-1.jpg',
  imgSm: 'images/master-img-1-mobile.jpg',
  imgAlt: '國際頂尖建築大師Kerry Hill',
},
{
  title: `新加坡豪宅推手-SCDA建築事務所<br>首席設計師Soo K.Chan`,
  content: '合作設計「南京涵碧樓酒店」。',
  img: 'images/master-img-2.jpg',
  imgSm: 'images/master-img-2-mobile.jpg',
  imgAlt: '新加坡豪宅推手SCDA首席設計師Soo',
}, {
  title: '世界頂級酒店設計大師 LTW林豐年',
  content: '合作設計南京涵碧樓酒店的中餐廳。',
  img: 'images/master-img-3.jpg',
  imgSm: 'images/master-img-3-mobile.jpg',
  imgAlt: '世界頂級酒店設計大師LTW林豐年',
},

];

export const thelaluInfos = [{
  subTitle: '日月潭涵碧樓',
  title: '自然與天地共好  涵碧樓酒店',
  content: '鄉林認為：「一棟好建築，尤其是度假酒店，應融入當地自然環境，並與天地共處。」這樣的想法，與國際建築大師Kerry Hill 一拍即合，因此日月潭涵碧樓、青島涵碧樓，鄉林集團與這位國際大師結下不解之緣。<br><br>Kerry Hill 期許與鄉林共同創造獨特的涵碧樓建築風格，不管是經歷了十幾、二十幾，或是百年以後，都能與時俱進，不顯老舊，反而能帶領時代向前，在每個時間點歷久彌新，輝映永恆的建築藝術價值。',
  img: 'images/thelalu-img-1.jpg',
  imgAlt: '自然與天地共好涵碧樓酒店',
},
{
  subTitle: '青島涵碧樓',
  title: '國際頂尖建築大師-Kerry Hill',
  content: '青島涵碧樓是一座飽含儒家隱居理想的濱海勝地，華屋美器，絲竹美饌，處處可見儒家古典文化的現代演繹，<br>由國際大師Kerry Hill 設計，延續日月潭<br>涵碧樓「極簡」、「禪風」的建築風格，並將東西美學結合唯一，細品青島涵碧樓不難發現，選材皆是原木、花崗石、玻璃和金屬四種自然低調的材料，<br>創造出宛如從自然景觀中誕生的建築，隨應歲月的遞嬗凸顯永恆價值。',
  img: 'images/thelalu-img-2.jpg',
  imgAlt: '國際頂尖建築大師-Kerry Hill',
},
{
  subTitle: '南京涵碧樓',
  title: '新加坡建築團隊- SCDA.SOO',
  content: '南京涵碧樓是鄉林集團繼「日月潭涵碧樓」、「青島涵碧樓」的第三代表作。<br><br>承襲涵碧樓一貫的「簡約禪風」，鄉林邀請新加坡知名SCDA 建築的SOO.K.CHAN 擔任設計，以水平和垂直的俐落線條，打造井然有序的建築外觀，猶如中國院牆圍合的皇城風格，佐以涵碧樓獨有水景文化與竹林元素，讓建築與自然融合為一。<br>夜幕低垂時，南京涵碧樓如「月光寶盒」，匯聚日月精華，是長江流域繁華都市之中最寧靜的秘境。',
  img: 'images/thelalu-img-3.jpg',
  imgAlt: '新加坡建築團隊- SCDA.SOO ',
},
];